module.exports = __webpack_public_path__ + "img/bg_image_2.99c039df.png";